import React, { useState, useEffect } from 'react';
import { Copy } from 'lucide-react';

const ApiKeysPanel = ({ backendUrl }) => {
  const [apiKeys, setApiKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copySuccess, setCopySuccess] = useState('');

  const fetchApiKeys = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${backendUrl}/admin/api-keys`, {
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error('Nie udało się pobrać kluczy API');
      }
      const data = await response.json();
      setApiKeys(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApiKeys();
  }, [backendUrl]);

  const handleGenerateKey = async (name) => {
    try {
      const response = await fetch(`${backendUrl}/admin/api-keys/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ name }),
      });
      if (!response.ok) {
        throw new Error('Nie udało się wygenerować klucza');
      }
      fetchApiKeys();
    } catch (err) {
      alert(err.message);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopySuccess('Skopiowano!');
      setTimeout(() => setCopySuccess(''), 2000);
    }, () => {
      setCopySuccess('Błąd kopiowania');
      setTimeout(() => setCopySuccess(''), 2000);
    });
  };

  if (loading) {
    return <div>Ładowanie...</div>;
  }

  if (error) {
    return <div style={{ color: "red" }}>Błąd: {error}</div>;
  }

  const templateCheckKey = apiKeys.find(key => key.name === 'template-check');
  const externalOrdersKey = apiKeys.find(key => key.name === 'external_orders_api');

  const renderKeySection = (title, description, keyData, keyName) => (
    <div className="api-key-section orders-table" style={{ marginBottom: '2rem', padding: '1rem', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      <p>{description}</p>
      {keyData ? (
        <div className="api-key-display">
          <table className="orders-table">
            <tbody>
              <tr>
                <td style={{ width: '120px' }}><strong>Nazwa:</strong></td>
                <td>{keyData.name}</td>
              </tr>
              <tr>
                <td><strong>Klucz:</strong></td>
                <td>
                  <code style={{ background: '#f0f0f0', padding: '2px 4px', borderRadius: '4px', marginRight: '10px' }}>
                    {keyData.key}
                  </code>
                  <button onClick={() => copyToClipboard(keyData.key)} className="orders-button" style={{ padding: '5px 10px' }}>
                    <Copy size={16} />
                  </button>
                </td>
              </tr>
              <tr>
                <td><strong>Utworzono:</strong></td>
                <td>{new Date(keyData.createdAt).toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <p>Brak klucza. Wygeneruj nowy.</p>
      )}
      <button onClick={() => handleGenerateKey(keyName)} className="orders-button" style={{ marginTop: '1rem' }}>
        {keyData ? 'Wygeneruj ponownie' : 'Wygeneruj Klucz'}
      </button>
    </div>
  );

  return (
    <div className="orders-container" style={{ marginTop: 20 }}>
      <h3>Zarządzanie Kluczami API</h3>
      {copySuccess && <div style={{ color: 'green', marginBottom: '1rem' }}>{copySuccess}</div>}
      
      {renderKeySection(
        'Klucz API do tworzenia zamówień',
        <>Ten klucz jest używany w publicznym endpoincie <code>/public/api/orders</code> do tworzenia nowych zamówień przez zewnętrzne aplikacje.</>,
        externalOrdersKey,
        'external_orders_api'
      )}

      {renderKeySection(
        'Klucz API do sprawdzania istnienia szablonu',
        <>Ten klucz jest używany w publicznym endpoincie <code>/public/templates/check/:templateId/:apiKey</code> do weryfikacji, czy dany szablon istnieje w systemie.</>,
        templateCheckKey,
        'template-check'
      )}
    </div>
  );
};

export default ApiKeysPanel;
